export const SOCIAL_SHARING_FACEBOOK = 'facebook';
export const SOCIAL_SHARING_TWITTER = 'twitter';
export const SOCIAL_SHARING_LINKED_IN = 'linked-in';
export const SOCIAL_SHARING_LINK = 'link';
export const SOCIAL_SHARING_PRINT = 'print';
export const SOCIAL_SHARING_PROVIDERS = [
    SOCIAL_SHARING_FACEBOOK,
    SOCIAL_SHARING_TWITTER,
    SOCIAL_SHARING_LINKED_IN,
    SOCIAL_SHARING_LINK,
];
export const SHARE_BUTTON_TRANSLATION_KEYS = {
    [SOCIAL_SHARING_FACEBOOK]: 'share-button.via-facebook',
    [SOCIAL_SHARING_TWITTER]: 'share-button.via-twitter',
    [SOCIAL_SHARING_LINKED_IN]: 'share-button.via-linked-in',
    [SOCIAL_SHARING_LINK]: 'share-button.via-link',
    [SOCIAL_SHARING_PRINT]: 'post-actions.print',
};
export const PROVIDER_TITLE_TRANSLATION_KEYS = {
    [SOCIAL_SHARING_FACEBOOK]: 'social-sharing.facebook',
    [SOCIAL_SHARING_TWITTER]: 'social-sharing.twitter',
    [SOCIAL_SHARING_LINKED_IN]: 'social-sharing.linked-in',
    [SOCIAL_SHARING_LINK]: 'social-sharing.link',
    [SOCIAL_SHARING_PRINT]: 'social-sharing.print-post',
};
//# sourceMappingURL=social-sharing.js.map